<template>
<div class="button-group">
    <div class="btn-group horizontal">
        <button class="btn" @click="changeCurrentProduct(radio.id)" :class="radio.id == currentRadio.id ? 'active' : ''">{{ radio.name }}</button>
        <button v-for="subproduct in subproducts" :key="subproduct.id" class="btn" @click="changeCurrentProduct(subproduct.id)"
        :class="subproduct.id == currentRadio.id ? 'active' : ''">{{subproduct.name}}</button>
    </div>
</div>
</template>

<script>
export default {
  name: 'SubproductTabComponent',
  props: {
    section: Object,
    radio: Object,
    currentRadio: Object,
    subproducts: Array
  },
  methods: {
    changeCurrentProduct(clickedSubProductId) {
      if(clickedSubProductId === this.currentRadio.id) {
        return;
      }

      if(clickedSubProductId === this.radio.id) {
        this.$router.push({ name: this.section.prefix, params: { product: this.radio.fileName } });
      }
      else {
        let subproduct = this.subproducts.find(subproduct => subproduct.id === clickedSubProductId);

        this.$router.replace({
          name: this.section.prefix + 'subproduct',
          params: { product: this.radio.fileName, subproduct: subproduct.fileName }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.button-group {
  margin-left: 1.5rem;
}
</style>
